export default "__VITE_ASSET__B8L8s2s6__"